module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Progress"},"fr":{"title":"Progression"}}')
  delete Component.options._Ctor
}
